<template>
  <div class="">
    <el-upload
      :multiple="true"
      :show-file-list="true"
      class="upload-demo"
      :action="actionPath"
      :on-remove="handleRemove"
      :file-list="value"
      :on-success="handleSuccess"
      :before-upload="beforeUpload"
      :http-request="handleFileChange"
    >
      <el-button size="small" type="primary">点击上传</el-button>
      <!-- <div slot="tip" class="el-upload__tip">
        只能上传jpg/png文件，且不超过500kb
      </div> -->
    </el-upload>
  </div>
</template>

<script>
import { guid } from '@/utils/index'
import AWS from 'aws-sdk'
export default {
  name: 'UploadDoc',
  props: {
    value: {
      type: Array,
      default() {
        return []
      },
    },
    color: {
      type: String,
      default: '#1890ff',
    },
    // 限制上传文件类型
    accept: {
      type: String,
      default: 'image/*,video/*',
    },
    // 上传文件夹
    uploadFolder: {
      type: String,
      default: '',
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  computed: {
    input: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('change', val)
      },
    },
  },
  data() {
    return {
      listObj: {},
      fileList: [],
      actionPath: '',
      baseUrl: '',
      postData: {},
      s3: new AWS.S3({
        // AWS 认证相关
        accessKeyId: 'AKIA535ZCMMRQCQ4EXK7',
        secretAccessKey: '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',
        region: 'us-east-2',
      }),
      domain: 'https://img.hisynergy.shop/',
    }
  },
  mounted() {},
  methods: {
    checkAllSuccess() {
      return Object.keys(this.listObj).every(
        (item) => this.listObj[item].hasSuccess
      )
    },
    handleSubmit() {
      return new Promise((resolve, reject) => {
        const arr = Object.keys(this.listObj).map((v) => this.listObj[v])
        if (!this.checkAllSuccess()) {
          this.$message(
            '请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！'
          )
          return
        }
        console.log(arr)
        this.$emit('uploaddoc', arr)
        // this.listObj = {}
        // this.fileList = []
        // this.dialogVisible = false
        resolve()
      })
    },
    handleSuccess(response, file) {
      console.log(file)
      const uid = file.uid
      const objKeyArr = Object.keys(this.listObj)
      console.log(objKeyArr)

      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          this.listObj[objKeyArr[i]].url =
            process.env.VUE_APP_AWS_S3_DOMAIN + response.key
          this.listObj[objKeyArr[i]].hasSuccess = true
          this.listObj[objKeyArr[i]] = {
            ...this.listObj[objKeyArr[i]],
            file_name: this.listObj[objKeyArr[i]].name,
            file_path: response.key,
          }
          //   this.value.splice(
          //     this.value.findIndex((item) => {
          //       return item.uid == uid
          //     }),
          //     1,
          //     {
          //       ...this.listObj[objKeyArr[i]],
          //       file_name: this.listObj[objKeyArr[i]].name,
          //       file_path: this.listObj[objKeyArr[i]].url,
          //     }
          //   )
          //   console.log(this.listObj)
          //   this.$emit('change', this.value.concat(datavalue))
          console.log(this.value)
          const arr = Object.keys(this.listObj).map((v) => this.listObj[v])
          console.log(arr)
          this.$emit('change', this.value.concat(arr))
          return
        }
      }
      //   this.$emit('change', this.value.concat(datavalue))
      //   console.log(this.listObj)
      //   console.log(this.value)
    },
    handleRemove(file) {
      const uid = file.uid
      this.value.splice(
        this.value.findIndex((item) => {
          return item.uid == uid
        }),
        1
      )
      const objKeyArr = Object.keys(this.listObj)
      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          delete this.listObj[objKeyArr[i]]
          return
        }
      }
    },
    beforeUpload(file) {
      console.log(file)
      const _self = this
      const _URL = window.URL || window.webkitURL
      const fileName = file.uid
      this.listObj[fileName] = {}
      const img = new Image()
      img.src = _URL.createObjectURL(file)
      this.listObj[file.uid] = {
        hasSuccess: false,
        uid: file.uid,
        name: file.name,
        width: this.width,
        height: this.height,
      }
    },
    handleFileChange(option) {
      console.log(option)
      const file = option.file
      if (file) {
        const key = guid() + '.' + file.type.split('/')[1]
        // const key = file.name
        const folder = this.uploadFolder + process.env.NODE_ENV + '/'
        const params = {
          Bucket: 'mlmvipsystem', // 存储佣名称
          Key: folder + key, // 文件名,重名会覆盖
          Body: file,
          ContentType: file.type,
        }
        const res = this.s3.upload(params)
        return res.promise()
      } else {
        this.$message('获取文件信息失败')
      }
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.editor-slide-upload {
  margin-bottom: 20px;
  ::v-deep.el-upload--picture-card {
    width: 100%;
  }
}
</style>
